import { Head, usePage } from "@inertiajs/react";
import { GlobalStyle } from "../../constants/global-style";
import ProvideLoggedInUser from "../../providers/ProvideLoggedInUser";
import SectionErrorBoundary from "../../homes/SectionErrorBoundary";
import SertifikasiApp from "../../sertifikasi/App";
import Breadcrumbs from "../../sertifikasi/Breadcrumbs";
import CourseHero from "../../sertifikasi/sections/CourseHero";
import CourseCertificate from "../../sertifikasi/sections/CourseCertificate";
import CourseCurriculumList from "../../sertifikasi/sections/CourseCurriculumList";
import RelatedCourses from "../../sertifikasi/sections/RelatedCourses";

// Inertia page for SertifikasiController#show_course when
// `sertifikasi_rebrand_v1` is ON. Legacy /courses/:id/show_v2 is served
// otherwise — controller branches on the toggle.
export default function Course() {
  const { theme = "light", course = {} } = usePage().props;
  const title = course.name || "Sertifikasi";
  const description = (course.description || title).slice(0, 160);

  return (
    <>
      <Head>
        <title>{`${title} — Taxsam Learning Center`}</title>
        <meta name="description" content={description} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        {course.banner_image_url && (
          <meta property="og:image" content={course.banner_image_url} />
        )}
        {course.banner_image_url && (
          <link
            rel="preload"
            as="image"
            href={course.banner_image_url}
            fetchpriority="high"
          />
        )}
      </Head>
      <GlobalStyle />
      <ProvideLoggedInUser>
        <SertifikasiApp theme={theme}>
          <Breadcrumbs items={course.breadcrumbs || []} />
          <SectionErrorBoundary name="CourseHero">
            <CourseHero course={course} />
          </SectionErrorBoundary>
          <SectionErrorBoundary name="CourseCertificate">
            <CourseCertificate course={course} />
          </SectionErrorBoundary>
          <SectionErrorBoundary name="CourseCurriculumList">
            <CourseCurriculumList
              curriculums={course.curriculums || []}
              comingSoon={!!course.coming_soon}
            />
          </SectionErrorBoundary>
          <SectionErrorBoundary name="RelatedCourses">
            <RelatedCourses courses={course.related_courses || []} />
          </SectionErrorBoundary>
        </SertifikasiApp>
      </ProvideLoggedInUser>
    </>
  );
}
